import React, { useMemo } from 'react';
import RFQDetailsPageStore, { PageStoreContext } from 'store/pages/rfq/rfq-response/rfq-details/pageStore';
import RFQDetailsContent from 'components/rfq/quote/rfq-details';
import RFQStatusLayout from 'components/common/rfq/RFQStatusLayout';

const RFQDetailsPage: React.FC = () => {
  const pageStore = useMemo(() => new RFQDetailsPageStore(), []);

  return (
    <RFQStatusLayout>
      <PageStoreContext.Provider value={pageStore}>
        <RFQDetailsContent />
      </PageStoreContext.Provider>
    </RFQStatusLayout>
  );
};

export default RFQDetailsPage;
